let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1jsQH"), load("i5eMd"), load("bv8GZ"), load("5Lpne")]).then(() => parcelRequire('2AHGb'));